export const SIGNER_DEFAULT = {
  signername: null,
  signeremail: null,
  iscreator: false,
  signerid: null,
  signercolor: null,
};

export const SIGNER_COLORS = [
  '#016c59',
  '#6943d0',
  '#d37522',
  '#A37072',
  '#C1C4B3',
  '#E39273',
  '#8DC5C0',
  '#E0D7CA',
  '#FFCA00',
  '#57CBAB',
];

export const DEFAULT_YESNO_NO_MESSAGE =
  'This agreement requires a YES here to proceed. If you have questions, please contact the agreement sender.';

export const DOCUMENT_COLOR = '#980043';

export const INPUTS_GROUPS = [
  {
    id: 'most-popular',
    icon: 'signature',
    title: 'Most popular',
  },
  {
    id: 'text-group',
    icon: 'font',
    title: 'Text',
  },
  {
    id: 'personal-info-group',
    icon: 'address-card',
    title: 'Personal information',
  },
  {
    id: 'date-group',
    icon: 'calendar-days',
    title: 'Date',
  },
  {
    id: 'user-check-group',
    icon: 'user-check',
    title: 'Verification',
  },
  {
    id: 'address-group',
    icon: 'map-location',
    title: 'Address',
  },
  {
    id: 'others-group',
    icon: 'square-plus',
    title: 'Others',
  },
];

export const INPUTS = [
  {
    id: 'inputtile-text',
    inputtileicon: 'pen',
    inputtiletitle: 'Text field',
    inputtiledescription: 'Enter info',
    inputtiletype: 'TEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['text-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-signature',
    inputtileicon: 'signature',
    inputtiletitle: 'Signature',
    inputtiledescription: 'Agree, sign, and add visual signature',
    inputtiletype: 'SIGNATUREINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-name',
    inputtileicon: 'user-edit',
    inputtiletitle: 'Name',
    inputtiledescription: 'Lewis Carroll',
    inputtiletype: 'NAMETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-email',
    inputtileicon: 'envelope',
    inputtiletitle: 'Email',
    inputtiledescription: 'ada@ll.com',
    inputtiletype: 'EMAILTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-signdate',
    inputtileicon: 'calendar-check',
    inputtiletitle: 'Sign date',
    inputtiledescription: 'Jan 12 2020',
    inputtiletype: 'SIGNDATEINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['date-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-jobtitle',
    inputtileicon: 'user-crown',
    inputtiletitle: 'Job title',
    inputtiledescription: 'VP of R&D',
    inputtiletype: 'JOBTITLETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-building',
    inputtileicon: 'building',
    inputtiletitle: 'Company',
    inputtiledescription: 'Oscorp',
    inputtiletype: 'COMPANYNAMETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-phonenumber',
    inputtileicon: 'mobile',
    inputtiletitle: 'Phone number',
    inputtiledescription: '415 867-5309',
    inputtiletype: 'PHONETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-fulladdress',
    inputtileicon: 'map-marked',
    inputtiletitle: 'Full Address',
    inputtiledescription: '221B Baker St, London NW1 6XE, UK',
    inputtiletype: 'ADDRESSTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group', 'most-popular'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-streetaddress',
    inputtileicon: 'house-building',
    inputtiletitle: 'Street Address',
    inputtiledescription: '521 Diagon Alley',
    inputtiletype: 'STREETADDRESSTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-city',
    inputtileicon: 'city',
    inputtiletitle: 'City',
    inputtiledescription: 'New Orleans',
    inputtiletype: 'CITYTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-state',
    inputtileicon: 'map-marker-alt',
    inputtiletitle: 'State',
    inputtiledescription: 'Louisiana',
    inputtiletype: 'STATETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-county',
    inputtileicon: 'map-pin',
    inputtiletitle: 'County',
    inputtiledescription: 'San Francisco County',
    inputtiletype: 'COUNTYTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-country',
    inputtileicon: 'earth-americas',
    inputtiletitle: 'Country',
    inputtiledescription: 'United States',
    inputtiletype: 'COUNTRYTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-postalcode',
    inputtileicon: 'mailbox',
    inputtiletitle: 'Zip Code',
    inputtiledescription: '70116',
    inputtiletype: 'ZIPCODETEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['address-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-eventdate',
    inputtileicon: 'calendar-day',
    inputtiletitle: 'Date',
    inputtiledescription: 'Jan 12 2020',
    inputtiletype: 'DATEINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['date-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-fee',
    inputtileicon: 'money-bill-alt',
    inputtiletitle: 'Fee',
    inputtiledescription: '$1,000',
    inputtiletype: 'FEEINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-duration',
    inputtileicon: 'calendar-week',
    inputtiletitle: 'Duration',
    inputtiledescription: '90 days',
    inputtiletype: 'DURATIONINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['date-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-html',
    inputtileicon: 'fas fa-list-alt',
    inputtiletitle: 'Paragraph',
    inputtiledescription: 'Detailed text',
    inputtiletype: 'HTMLINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['text-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-checkbox',
    inputtileicon: 'square-check',
    inputtiletitle: 'Checkbox',
    inputtiledescription: '[x] I agree',
    inputtiletype: 'CHECKBOXINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-url',
    inputtileicon: 'link',
    inputtiletitle: 'URL',
    inputtiledescription: 'www.hrbr.co',
    inputtiletype: 'URLTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-imagestampinput',
    inputtileicon: 'stamp',
    inputtiletitle: 'Upload Image',
    inputtiledescription: 'Content.jpg',
    inputtiletype: 'IMAGEINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-yesno',
    inputtileicon: 'check-circle',
    inputtiletitle: 'Yes/No field',
    inputtiledescription: 'Do you agree?',
    inputtiletype: 'YESNOINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-fileupload',
    inputtileicon: 'cloud-upload',
    inputtiletitle: 'File uploader',
    inputtiledescription: 'Feynman.mov',
    inputtiletype: 'FILEUPLOADER',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-dropdown',
    inputtileicon: 'list-dropdown',
    inputtiletitle: 'Dropdown',
    inputtiledescription: 'Take your pick',
    inputtiletype: 'DROPDOWNINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-ssn',
    inputtileicon: 'address-card',
    inputtiletitle: 'SSN',
    inputtiledescription: '092-09-6615',
    inputtiletype: 'SSNTEXTINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-gender',
    inputtileicon: 'user',
    inputtiletitle: 'Gender',
    inputtiledescription: 'Female',
    inputtiletype: 'GENDERDROPDOWNINPUT',
    inputtileeligibility: 'BOTH',
    type: 'INPUTTILE',
    group: ['personal-info-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-banner',
    inputtileicon: 'far fa-light fa-message',
    inputtiletitle: 'Custom Message',
    inputtiledescription: '(Say what you mean)',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'BANNERINPUT',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['text-group'],
    inputtileeligibleagreementinputtabs: ['DOCUMENT', 'SIGNER'],
  },
  {
    id: 'inputtile-identity-check',
    inputtileicon: 'user-check',
    inputtiletitle: 'Identity verification',
    inputtiledescription: 'Verify User with government ID',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'IDENTITYCHECK',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['user-check-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-us-background-check',
    inputtileicon: 'user-police-tie',
    inputtiletitle: 'US background check',
    inputtiledescription: 'Run US criminal record check',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'USBACKGROUNDCHECK',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['user-check-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-vehicle_record_check',
    inputtileicon: 'car-side',
    inputtiletitle: 'Motor vehicle check',
    inputtiledescription: 'Run motor vehicle record check',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'VEHICLERECORDCHECK',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['user-check-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-panel_drug_check',
    inputtileicon: 'vials',
    inputtiletitle: 'Panel drug test',
    inputtiledescription: 'Run panel drug test',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'PANELDRUGCHECK',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['user-check-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
  {
    id: 'inputtile-viewdocument',
    inputtileicon: 'far fa-light fa-file-pdf',
    inputtiletitle: 'Review document',
    inputtiledescription: 'Take a look',
    inputtileclassvalue: 'inputTile',
    inputtiletype: 'DISPLAYTEXT',
    inputtileeligibility: 'AGREEMENTFORMONLY',
    type: 'INPUTTILE',
    group: ['others-group'],
    inputtileeligibleagreementinputtabs: ['SIGNER'],
  },
];

export const TOOLBAR_ITEMS = [
  {
    id: 'inputtile-text',
    inputtileicon: 'input-text',
    type: 'text',
  },
  {
    id: 'inputtile-signature',
    inputtileicon: 'signature',
    type: 'signature',
  },
  {
    id: 'inputtile-fileupload',
    inputtileicon: 'image',
    type: 'image',
  },
  {
    id: 'inputtile-date',
    inputtileicon: 'calendar-days',
    type: 'date',
  },
  {
    id: 'inputtile-checkbox',
    inputtileicon: 'square-check',
    type: 'checkbox',
  },
];

// in pts
export const FONT_SIZE_DEFAULT = 12;
export const FONT_SIZE_MIN = 7;

export const ANNOTATION_WIDTH_DEFAULT = 235;
export const ANNOTATION_DIMENSIONS = {
  SIGNATUREINPUT: {
    width: 220,
    height: 40,
  },
  IMAGEINPUT: {
    width: 325,
    height: 305,
  },
  HTMLINPUT: {
    width: 350,
    height: 125,
  },
  BANNERINPUT: {
    width: 350,
    height: 125,
  },
  CHECKBOXINPUT: {
    width: 37,
    height: 37,
  },
  SIGNDATEINPUT: {
    width: 70,
    height: FONT_SIZE_DEFAULT,
  },
  DATEINPUT: {
    width: 70,
    height: FONT_SIZE_DEFAULT,
  },
};

export const SPECIAL_GEOMETRY_ANNOTATIONS = [
  'SIGNATUREINPUT',
  'HTMLINPUT',
  'BANNERINPUT',
  'IMAGEINPUT',
  'CHECKBOXINPUT',
];
export const NO_FONT_FAMILY_INPUTS = [
  'SIGNATUREINPUT',
  'HTMLINPUT',
  'CHECKBOXINPUT',
  'BANNERINPUT',
  'IMAGEINPUT',
  'FILEUPLOADER',
  'DISPLAYTEXT',
  'IDENTITYCHECK',
  'USBACKGROUNDCHECK',
  'VEHICLERECORDCHECK',
  'PANELDRUGCHECK',
];
export const NO_FONT_SIZE_CONTROL_INPUTS = [
  'SIGNATUREINPUT',
  'HTMLINPUT',
  'BANNERINPUT',
  'IMAGEINPUT',
  'CHECKBOXINPUT',
  'IDENTITYCHECK',
  'USBACKGROUNDCHECK',
  'VEHICLERECORDCHECK',
  'PANELDRUGCHECK',
];
export const NO_REQUIRED_ANSWER_INPUTS = ['CHECKBOXINPUT', 'BANNERINPUT'];
export const AUTOFILL_GEO_INPUTS = [
  'STREETADDRESSTEXTINPUT',
  'CITYTEXTINPUT',
  'STATETEXTINPUT',
  'ZIPCODETEXTINPUT',
  'COUNTRYTEXTINPUT',
  'COUNTYTEXTINPUT',
];
export const EDIT_LABEL_PROMPT_INPUTS = [
  'TEXTINPUT',
  'HTMLINPUT',
  'YESNOINPUT',
  'DATEINPUT',
  'CHECKBOXINPUT',
  'URLTEXTINPUT',
  'IMAGEINPUT',
  'FILEUPLOADER',
  'DROPDOWNINPUT',
];
export const TEXT_TYPE_INPUTS = [
  'TEXTINPUT',
  'NAMETEXTINPUT',
  'EMAILTEXTINPUT',
  'PHONETEXTINPUT',
  'JOBTITLETEXTINPUT',
  'SIGNDATEINPUT',
  'DATEINPUT',
  'DURATIONINPUT',
  'FEEINPUT',
];
export const AUTOCOMPLETE_TYPE_INPUTS = [
  'ADDRESSTEXTINPUT',
  'STREETADDRESSTEXTINPUT',
  'CITYTEXTINPUT',
  'STATETEXTINPUT',
  'ZIPCODETEXTINPUT',
  'COMPANYNAMETEXTINPUT',
  'COUNTRYTEXTINPUT',
  'COUNTYTEXTINPUT',
];
export const AUTOFILL_DOCUMENT_INPUTS = [
  'EMAILTEXTINPUT',
  'NAMETEXTINPUT',
  'JOBTITLETEXTINPUT',
  'PHONETEXTINPUT',
];
export const IMMUTABLE_INPUTS = ['CHECKBOX', 'FINALDISPLAYTEXT', 'FINALSUBMIT'];
export const CHECK_TYPE_INPUTS = [
  'IDENTITYCHECK',
  'USBACKGROUNDCHECK',
  'VEHICLERECORDCHECK',
  'PANELDRUGCHECK',
];

export const DROPDOWN_INPUTS = ['DROPDOWNINPUT', 'SELECT'];

export const CONDITIONAL_LOGIC_TYPES = [
  'DROPDOWNINPUT',
  'YESNOINPUT',
  'CHECKBOXINPUT',
  'IDENTITYCHECK',
  'USBACKGROUNDCHECK',
  'VEHICLERECORDCHECK',
  'PANELDRUGCHECK',
  'COUNTRYTEXTINPUT',
];

export const INPUT_ICON_CHOICES = [
  'user',
  'star',
  'calendar-day',
  'map-marked-alt',
  'globe',
  'link',
  'check',
  'birthday-cake',
  'envelope',
  'building',
  'city',
  'mobile',
  'video',
  'comment-lines',
  'smile',
  'user-friends',
  'user-crown',
  'user-hard-hat',
  'user-check',
  'id-card',
  'at',
  'flag',
  'industry-alt',
  'briefcase',
  'camera',
  'user-tie',
  'phone-office',
  'money-check-edit-alt',
  'exchange',
  'sack-dollar',
  'university',
  'hashtag',
  'clock',
  'user-clock',
  'location-arrow',
  'hat-wizard',
  'box-open',
  'exclamation-circle',
  'file-pdf',
  'chart-line',
  'copyright',
  'wheelchair',
  'dog',
  'cat',
  'heart',
  'user-secret',
];

// display names and actual names (when display name != actual name)
export const AVAILABLE_FONTS = {
  Arial: null,
  Helvetica: null,
  Calibri: null,
  'Times New Roman': null,
  Courier: null,
  Roboto: null,
  Verdana: null,
  Signature: 'La Belle Aurore',
  Zeyada: null,
  'La Belle Aurore': null,
  'Open Sans': null,
  'Comic Sans': null,
  Papyrus: null,
};

export const AGREEMENT_INPUT = {
  itemfieldtype: 'TEXTINPUT',
  itemdisplaylabel: '',
  itemrecordlabel: null,
  isitemoptionsexpanded: false,
  isitemoptionsexpandedadvanced: false,
  isitemiconchoicesexpanded: false,
  isitemlinkedinputsexpanded: false,
  itemcolor: null,
  isrequired: true,
  isrequiredyes: true,
  isrequiredyesnomesssage:
    'This agreement requires a YES here to proceed. If you have questions, please contact the agreement sender.',
  id: null, // auto-generated
  type: 'AGREEMENTINPUT',
  inputtype: null, // e.g., "SIGNER", "DOCUMENT"
  inputhtml5type: null,
  inputhtml5name: null,
  icon: 'pen',
  itemtypeconfig: {},
  itemannotationexampletext: null,
  // itemcheckedvalueyes: 'Yes', // CHECKBOX
  // itemcheckedvalueno: 'No', // CHECKBOX
  itemyesnovalueyes: 'Yes', // YESNO
  itemyesnovalueno: 'No', // YESNO
  isrequiredchecked: false, // CHECKBOXINPUT
  itemsource: null,
  itemdescriptiontext: null,
  itemdefaultvalue: null,
  itemplaceholdertext: 'Enter value',
  itemisdisabled: false,
  itemdisplayeligiblity: null,
  itemsuffixvalue: null, // e.g., "Days"
  itemoptions: null, // i.e., SELECT options - e.g,, ["Beatles","Elvis"]
  isconditionallydisplayedlinkeditemid: null,
  isconditionallydisplayedlinkeditemvalue: null,
  itemcontent: null, // e.g., DISPLAYTEXT html
  ishidden: false,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  isurlparametervalueenabled: false,
  urlparameterid: null,
  autocompletegroupid: null,
  // conditional logic
  isitemlogicexpanded: false,
  logicrules: [],
  haslogic: false,
  logicinputtype: null,
  fontfamily: null,
  sectionid: null,
  renderhtmlinagreement: false,
  requiredsettingslabel: 'Required answer',
  requiredsettingstext: 'Item answer is required',
  requiredsettingstextstyle: null,
  autoaddedinputsmap: {},
  isalldefaultfieldshidden: false,
  internalinputname: null,
  autoaddeditem: false,
  autoaddedinternalname: '',
  itemcontenttext: '',
  inputmaskvalue: null,
  parents: [],
};

export const AGREEMENT_INPUT_TEXTINPUT = {
  itemfieldtype: 'TEXTINPUT',
  icon: 'pen',
  itemdisplaylabel: 'Enter your info',
  inputhtml5type: 'text',
  inputhtml5name: 'text',
  itemplaceholdertext: 'Enter info',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_SIGNATUREINPUT = {
  itemfieldtype: 'SIGNATUREINPUT',
  icon: 'signature',
  itemdisplaylabel: 'Sign here',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: null,
  itemisdisabled: true,
  itemdefaultvalue: 'Signature pad',
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_NAMETEXTINPUT = {
  itemfieldtype: 'NAMETEXTINPUT',
  icon: 'user-edit',
  itemdisplaylabel: 'Enter your full name',
  inputhtml5type: 'text',
  inputhtml5name: 'name',
  itemplaceholdertext: 'Enter full name',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemvalidations: [
    {
      itemvalidationtype: 'NAMEINPUT',
    },
    {
      itemvalidationtype: 'MINLENGTH',
      itemvalidationvalue: 2,
    },
  ],
};

export const AGREEMENT_INPUT_EMAILTEXTINPUT = {
  itemfieldtype: 'EMAILTEXTINPUT',
  icon: 'envelope',
  itemdisplaylabel: 'Enter your email',
  inputhtml5type: 'email',
  inputhtml5name: 'email',
  itemplaceholdertext: 'Enter email',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_SIGNDATEINPUT = {
  itemfieldtype: 'SIGNDATEINPUT',
  icon: 'calendar-check',
  itemdisplaylabel: 'Sign date',
  inputhtml5type: 'date',
  inputhtml5name: 'date',
  itemplaceholdertext: '-- Sign Date --',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'PDFONLY',
  itemtypeconfig: {
    datetype: 'SIGNDATE',
    datetimezone: 'NEWYORK',
    inputformat: 'mmm dd yyyy',
    itemformatpython: '%b %d %Y',
  },
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_DATEINPUT = {
  itemfieldtype: 'DATEINPUT',
  icon: 'calendar-day',
  itemdisplaylabel: 'Enter the date',
  inputhtml5type: 'date',
  inputhtml5name: 'date',
  itemplaceholdertext: 'Enter date',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemtypeconfig: {
    datetype: 'USERINPUTTED',
    datetimezone: 'NEWYORK',
    inputformat: 'mmm dd yyyy',
    itemformatpython: '%b %d %Y',
  },
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemvalidations: [],
};

export const AGREEMENT_INPUT_ADDRESSTEXTINPUT = {
  itemfieldtype: 'ADDRESSTEXTINPUT',
  icon: 'map-marked',
  itemdisplaylabel: 'Enter your full address',
  inputhtml5type: 'text',
  inputhtml5name: null,
  itemplaceholdertext: 'Enter full address',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: true,
  autocompletesuggestionstype: 'ADDRESS',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_STREETADDRESSTEXTINPUT = {
  itemfieldtype: 'STREETADDRESSTEXTINPUT',
  icon: 'house-building',
  itemdisplaylabel: 'Enter your street address',
  inputhtml5type: 'street',
  inputhtml5name: 'street',
  itemplaceholdertext: 'Enter street address',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: true,
  autocompletesuggestionstype: 'STREETADDRESS',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_YESNOINPUT = {
  autocompletesuggestionstype: null,
  checkcount: 0,
  // conditional logic
  haslogic: true,
  icon: 'check-circle',
  inputcustomstyle: null,
  inputhtml5name: null,
  inputhtml5type: null,
  isautocompleteenabled: false,
  isautocompletewithfullsuggestiontext: false,
  isautocompletewithmaps: false,
  itemcheckedvalueno: null,
  itemcheckedvalueyes: null,
  itemdefaultvalue: '-- yes/no selection --',
  itemdisplayeligiblity: 'BOTH',
  itemdisplaylabel: 'Is this info correct?',
  itemfieldtype: 'YESNOINPUT',
  itemisdisabled: true,
  itemoptions: ['YES', 'NO'],
  itemplaceholdertext: null,
  itemrecordlabel: null,
  itemrespondednomessage: DEFAULT_YESNO_NO_MESSAGE,
  itemrespondedyesmessage: null,
  itemsuffixvalue: null,
  logicinputtype: 'choice',
};

export const AGREEMENT_INPUT_PHONETEXTINPUT = {
  itemfieldtype: 'PHONETEXTINPUT',
  icon: 'mobile',
  itemdisplaylabel: 'Enter your phone number',
  inputhtml5type: 'tel',
  inputhtml5name: 'tel',
  itemplaceholdertext: 'Enter phone number',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  inputmaskvalue: '(###)###-####',
  itemvalidations: [],
};

export const AGREEMENT_INPUT_COMPANYNAMETEXTINPUT = {
  itemfieldtype: 'COMPANYNAMETEXTINPUT',
  icon: 'building',
  itemdisplaylabel: 'Enter company name',
  inputhtml5type: 'address',
  inputhtml5name: 'address',
  itemplaceholdertext: 'Enter company',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'ESTABLISHMENT',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_FILEUPLOADER = {
  itemfieldtype: 'FILEUPLOADER',
  icon: 'cloud-upload',
  itemdisplaylabel: 'Upload content',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: null,
  itemisdisabled: true,
  itemdefaultvalue: '-- file uploader --',
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_IMAGEINPUT = {
  itemfieldtype: 'IMAGEINPUT',
  icon: 'image',
  itemdisplaylabel: 'Upload your image',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: null,
  itemisdisabled: true,
  itemdefaultvalue: '-- upload --',
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemtypeconfig: {
    multiple: false,
    imagescount: 1,
  },
};

export const AGREEMENT_INPUT_STATETEXTINPUT = {
  itemfieldtype: 'STATETEXTINPUT',
  icon: 'map-marker-alt',
  itemdisplaylabel: 'Enter state',
  inputhtml5type: 'state',
  inputhtml5name: 'state',
  itemplaceholdertext: 'Enter state',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'STATES',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemvalidations: [
    {
      itemvalidationtype: 'STATEINPUT',
    },
  ],
};

export const AGREEMENT_INPUT_CITYTEXTINPUT = {
  itemfieldtype: 'CITYTEXTINPUT',
  icon: 'city',
  itemdisplaylabel: 'Enter city',
  inputhtml5type: 'city',
  inputhtml5name: 'city',
  itemplaceholdertext: 'Enter city',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'CITIES',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_COUNTYTEXTINPUT = {
  itemfieldtype: 'COUNTYTEXTINPUT',
  icon: 'map-pin',
  itemdisplaylabel: 'Enter county',
  inputhtml5type: 'county',
  inputhtml5name: 'county',
  itemplaceholdertext: 'Enter county',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'COUNTIES',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_COUNTRYTEXTINPUT = {
  itemfieldtype: 'COUNTRYTEXTINPUT',
  icon: 'earth-americas',
  itemdisplaylabel: 'Select country',
  inputhtml5type: 'country',
  inputhtml5name: 'country',
  itemplaceholdertext: 'Select country',
  itemisdisabled: true, // don't v-model itemdefaultvalue
  itemdefaultvalue: null, // must be null for placeholder to show
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  maxitemoptions: 200,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'COUNTRIES',
  checkcount: 0,
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
  itemvalidations: [
    {
      itemvalidationtype: 'COUNTRYINPUT',
    },
  ],
};

export const AGREEMENT_INPUT_ZIPCODETEXTINPUT = {
  itemfieldtype: 'ZIPCODETEXTINPUT',
  icon: 'mailbox',
  itemdisplaylabel: 'Enter zip code',
  inputhtml5type: 'zipcode',
  inputhtml5name: 'zipcode',
  itemplaceholdertext: 'Enter zip code',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: true,
  isautocompletewithmaps: true,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: 'REGIONS',
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemvalidations: [
    {
      itemvalidationtype: 'ZIPCODE',
    },
  ],
};

export const AGREEMENT_INPUT_JOBTITLETEXTINPUT = {
  itemfieldtype: 'JOBTITLETEXTINPUT',
  icon: 'user-crown',
  itemdisplaylabel: 'Enter job title',
  inputhtml5type: 'text',
  inputhtml5name: 'jobtitle',
  itemplaceholdertext: 'Enter job title',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_HTMLINPUT = {
  itemfieldtype: 'HTMLINPUT',
  icon: 'paragraph',
  itemdisplaylabel: 'Enter paragraph text',
  inputhtml5type: 'textarea',
  inputhtml5name: 'text',
  itemplaceholdertext: 'Enter paragraph text',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_FEEINPUT = {
  itemfieldtype: 'FEEINPUT',
  icon: 'money-bill-alt',
  itemdisplaylabel: 'Fee amount',
  inputhtml5type: 'text',
  inputhtml5name: 'fee',
  itemplaceholdertext: 'Enter number',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: 'USD',
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_DURATIONINPUT = {
  itemfieldtype: 'DURATIONINPUT',
  icon: 'calendar-week',
  itemdisplaylabel: 'Enter duration',
  inputhtml5type: 'number',
  inputhtml5name: 'number',
  itemplaceholdertext: 'Enter duration',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: 'Days',
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_SELECT = {
  itemfieldtype: 'SELECT',
  icon: null,
  itemdisplaylabel: 'Enter a selection',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: '-- Select option --',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: [],
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_CHECKBOXINPUT = {
  itemfieldtype: 'CHECKBOXINPUT',
  icon: 'check-square',
  itemdisplaylabel: 'Check all that apply',
  itemcheckboxlabel: null,
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: '-- Checkboxes --',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: [],
  maxitemoptions: 100,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: 'x',
  itemcheckedvalueno: '',
  isrequired: false,
  typechecksrequired: 'min',
  numchecksrequired: 1,
  checkcount: 0,
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
};

export const AGREEMENT_INPUT_URLTEXTINPUT = {
  itemfieldtype: 'URLTEXTINPUT',
  icon: 'link',
  itemdisplaylabel: 'Enter a URL',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: 'Enter a URL',
  itemisdisabled: false,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_DROPDOWNINPUT = {
  itemfieldtype: 'DROPDOWNINPUT',
  icon: 'list-dropdown',
  itemdisplaylabel: 'Select an option',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: 'Select an option',
  itemisdisabled: true, // don't v-model itemdefaultvalue
  itemdefaultvalue: null, // must be null for placeholder to show
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: ['Option 1', 'Option 2'],
  maxitemoptions: 100,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  checkcount: 0,
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
};

export const AGREEMENT_INPUT_SSNTEXTINPUT = {
  itemfieldtype: 'SSNTEXTINPUT',
  icon: 'address-card',
  itemdisplaylabel: 'Enter your SSN',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: 'Enter your SSN',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
};

export const AGREEMENT_INPUT_BANNERINPUT = {
  itemfieldtype: 'BANNERINPUT',
  icon: 'message',
  itemdisplaylabel: 'Custom message',
  inputhtml5type: 'textarea',
  inputhtml5name: 'text',
  itemplaceholdertext: '-- Add custom content in settings --',
  itemisdisabled: true,
  itemdefaultvalue: null,
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  itemoptions: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  isrequired: false,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
};

const SHARED_CONSENTS = [
  {
    consenttype: 'FCRA_CONSENT',
    consenttitle: 'FCRA Consent',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: {}, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      COMPANYNAMETEXTINPUT: null,
      SIGNATUREINPUT: null,
      NAMETEXTINPUT: null,
      SIGNDATEINPUT: null,
    },
  },
  {
    consenttype: 'FCRA_DISCLOSUER',
    consenttitle: 'FCRA Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: {}, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      COMPANYNAMETEXTINPUT: null,
    },
  },
  {
    consenttype: 'ADDITIONAL_RIGHTS',
    consenttitle: 'Additional Rights',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: {}, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'SUMMARY_OF_RIGHTS',
    consenttitle: 'Summary of Rights',
    isviewed: false,
    iscompleted: false,
    ispdf: true,
    triggers: {}, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'CA_DISCLOSUER',
    consenttitle: 'CA - Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['california', 'california state', 'ca'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      COMPANYNAMETEXTINPUT: null,
      CHECKBOXINPUT: null,
    },
  },
  {
    consenttype: 'CA_LA_NOTICE',
    consenttitle: 'CA - LA Required Notice',
    isviewed: false,
    iscompleted: false,
    ispdf: true,
    triggers: {
      state: ['california', 'california state', 'ca'],
      county: ['los angeles', 'los angeles county', 'la'],
    }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'CA_SF_NOTICE',
    consenttitle: 'CA - SF Required Notice',
    isviewed: false,
    iscompleted: false,
    ispdf: true,
    triggers: {
      state: ['california', 'california state', 'ca'],
      county: ['san francisco', 'san francisco county', 'sf'],
    }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'MA_DICLOSURE',
    consenttitle: 'MA - Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['massachusetts', 'massachusetts state', 'ma'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      CHECKBOXINPUT: null,
    },
  },
  {
    consenttype: 'MN_REPORT_REQUEST',
    consenttitle: 'MN - Report Request',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['minnesota', 'minnesota state', 'mn'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      CHECKBOXINPUT: null,
    },
  },
  {
    consenttype: 'NJ_DICLOSURE',
    consenttitle: 'NJ - Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['new jersey', 'new jersey state', 'nj'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'NY_DICLOSURE',
    consenttitle: 'NY - Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['new york', 'new york state', 'ny'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
  {
    consenttype: 'OK_REPORT_REQUEST',
    consenttitle: 'OK - Report Request',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['oklahoma', 'oklahoma state', 'ok'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {
      CHECKBOXINPUT: null,
    },
  },
  {
    consenttype: 'WA_DISCLOSURE',
    consenttitle: 'WA - Disclosure',
    isviewed: false,
    iscompleted: false,
    ispdf: false,
    triggers: { state: ['washington', 'washington state', 'wa', 'district of columbia', 'dc'] }, //*or "state:california"
    vieweddatetimeepochms: null,
    completeddatetimeepochms: null,
    inputs: {},
  },
];

export const AGREEMENT_INPUT_IDENTITY_CHECK = {
  itemisdisabled: true,
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemdefaultvalue: null,
  itemcontenttext: 'Verify identity with a government-issued ID',
  icon: 'user-check',
  itemiconpack: 'fas',
  itemfieldtype: 'IDENTITYCHECK',
  itemdisplaylabel: 'Identity verification',
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
  itemoptions: ['In progress', 'Verified', 'In review'],
  itemtypeconfig: {
    provider: 'certn',
    itemconsents: [
      ...SHARED_CONSENTS,
      {
        consenttype: 'BIOMETRIC_CONSENT',
        consenttitle: 'Biometric consent',
        isviewed: false,
        iscompleted: false,
        ispdf: false,
        triggers: {}, //*or "state:california"
        vieweddatetimeepochms: null,
        completeddatetimeepochms: null,
        inputs: {},
      },
    ],
  },
};

export const VERIFICATION_PROVIDER_DEFAULT_CONFIG = {
  certn: {
    provider: 'certn',
    itemconsents: [...SHARED_CONSENTS],
    checktype: 'request_us_criminal_record_check_tier_1',
  },
  turn_ai: {
    provider: 'turn_ai',
    itemconsents: null,
    checktype: null,
  },
};

export const AGREEMENT_INPUT_US_BACKGROUND_CHECK = {
  itemisdisabled: true,
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemdefaultvalue: null,
  itemcontenttext: 'Begin US background check',
  icon: 'user-police-tie',
  itemiconpack: 'fas',
  itemfieldtype: 'USBACKGROUNDCHECK',
  itemdisplaylabel: 'US background check',
  itemtypeconfig: {
    ...VERIFICATION_PROVIDER_DEFAULT_CONFIG.turn_ai,
  },
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
  itemoptions: ['In progress', 'Verified', 'In review'],
};

export const AGREEMENT_INPUT_VEHICLE_RECORD_CHECK = {
  itemisdisabled: true,
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemdefaultvalue: null,
  itemcontenttext: 'Begin motor vehicle record check',
  icon: 'car-side',
  itemiconpack: 'fas',
  itemfieldtype: 'VEHICLERECORDCHECK',
  itemdisplaylabel: 'Motor vehicle check',
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
  itemoptions: ['In progress', 'Verified', 'In review'],
  itemtypeconfig: {
    provider: 'certn',
    itemconsents: [
      ...SHARED_CONSENTS,
      {
        consenttype: 'NH_MVR_DISCLOSUER',
        consenttitle: 'New Hampshire - MVR Disclosure',
        isviewed: false,
        iscompleted: false,
        ispdf: false,
        triggers: { state: ['new hampshire', 'new hampshire state', 'nh'] }, //*or "state:california"
        vieweddatetimeepochms: null,
        completeddatetimeepochms: null,
        inputs: {},
      },
      {
        consenttype: 'WA_DRIVING_RECORD_RELEASE',
        consenttitle: 'WA - Driving Record Release',
        isviewed: false,
        iscompleted: false,
        ispdf: true,
        triggers: { state: ['washington', 'washington state', 'wa', 'district of columbia', 'dc'] }, //*or "state:california"
        vieweddatetimeepochms: null,
        completeddatetimeepochms: null,
        inputs: {
          SIGNATUREINPUT: null,
        },
      },
    ],
  },
};

export const AGREEMENT_INPUT_PANEL_DRUG_CHECK = {
  itemisdisabled: true,
  itemrecordlabel: null,
  itemsuffixvalue: null,
  inputcustomstyle: null,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemcheckedvalueyes: null,
  itemcheckedvalueno: null,
  checkcount: 0,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemdefaultvalue: null,
  itemcontenttext: 'Begin panel drug check',
  itemdisplaylabel: 'Panel drug test',
  icon: 'vials',
  itemiconpack: 'fas',
  itemfieldtype: 'PANELDRUGCHECK',
  itemtypeconfig: {
    provider: 'clear_star',
    checktype: '5 panel',
    itemconsents: [...SHARED_CONSENTS],
  },
  haslogic: true,
  itemoptions: ['In progress', 'Verified', 'In review'],
};

export const AGREEMENT_INPUT_GENDERINPUT = {
  itemfieldtype: 'DROPDOWNINPUT',
  icon: 'user',
  itemdisplaylabel: 'Select gender',
  inputhtml5type: null,
  inputhtml5name: null,
  itemplaceholdertext: 'Select gender',
  itemisdisabled: true, // don't v-model itemdefaultvalue
  itemdefaultvalue: null, // must be null for placeholder to show
  itemdisplayeligiblity: 'BOTH',
  itemrecordlabel: null,
  inputcustomstyle: null,
  itemsuffixvalue: null,
  itemoptions: ['Female', 'Male'],
  maxitemoptions: 100,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  checkcount: 0,
  // conditional logic
  haslogic: true,
  logicinputtype: 'choice',
};

export const AGREEMENT_INPUT_PDFPREVIEW = {
  isurlparametervalueenabled: false,
  urlparameterid: null,
  isconditionallydisplayedlinkeditemid: null,
  isconditionallydisplayedlinkeditemvalue: null,
  isdefaultdisplayed: true,
  isrequired: false,
  itemannotation: null,
  itemcallouttype: 'is-light',
  itemcontent: null, // this html will now be in template, but still honored when present
  itemdefaultvalue: null,
  itemdisplaylabel: 'Review document',
  icon: 'file-pdf',
  itemiconpack: 'fal',
  itemcolor: '',
  id: `agreementinput-agreementpdf-${Date.now()}-${Math.floor(Math.random() * 1000000000000)}`,
  iteminputtextmaxlength: 50,
  iteminputtextmaxlengthshowcounter: null,
  iteminputtype: null,
  itemiscalloutmsg: false,
  itemplaceholdertext: 'Please review the document',
  itemisdisabled: true,
  itemrecordlabel: null,
  itemrespondednomessage: null,
  itemrespondedyesmessage: null,
  itemspeciallinkedvalue: null,
  itemtype: 'DISPLAYTEXT',
  itemfieldtype: 'DISPLAYTEXT',
  iteminputtededitorselectiontype: 'DISPLAYTEXT',
  itemvalidations: [],
  itemvisiblerequiredindex: null,
  itemvisiblerequiredrole: null,
  isautoinserteddefaultitem: false,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  requiredsettingslabel: null,
  requiredsettingstext: 'Require signer to view',
  requiredsettingstextstyle: null,
};
export const AGREEMENT_INPUT_ACCEPTEDANDAGREED = {
  ...AGREEMENT_INPUT_YESNOINPUT,
  haslogic: false,
  id: `agreementinput-readagreedocumentyesno-${Date.now()}-${Math.floor(
    Math.random() * 1000000000000,
  )}`,
  isautoinserteddefaultitem: true,
  isconditionallydisplayedlinkeditemid: null,
  isconditionallydisplayedlinkeditemvalue: null,
  isdefaultdisplayed: true,
  isrequired: true,
  isurlparametervalueenabled: false,
  itemannotation: null,
  itemcallouttype: null,
  itemcheckboxlabel: null,
  itemcheckedvalueno: 'NO',
  itemcheckedvalueyes: 'YES',
  itemcontent: null,
  itemdefaultvalue: [],
  itemdisplayeligiblity: 'AGREEMENTFORMONLY',
  itemdisplaylabel: 'Have you read and do you accept the terms of the document?',
  itemiconpack: 'fal',
  itemcolor: '',
  iteminputname: null,
  iteminputtededitorselectiontype: 'YESNOINPUT',
  iteminputtextmaxlength: 400,
  iteminputtextmaxlengthshowcounter: false,
  iteminputtype: null,
  itemiscalloutmsg: null,
  itemplaceholdertext: null,
  itemrecordlabel: 'Read document and agreed to terms',
  itemrespondednomessage: DEFAULT_YESNO_NO_MESSAGE,
  itemrespondedyesmessage: null,
  itemspeciallinkedvalue: null,
  itemtype: 'YESNO',
  itemvalidations: [
    {
      itemvalidationtype: 'REQUIREDINPUT',
    },
    {
      itemvalidationtype: 'REQUIREDYES',
    },
  ],
  itemvisiblerequiredindex: null,
  itemvisiblerequiredrole: null,
  itemyesnovalueno: ['No'],
  itemyesnovalueyes: ['Yes'],
  sectionid: null,
  urlparameterid: null,
};

export const AGREEMENT_INPUT_ESIGNATURE = {
  isurlparametervalueenabled: false,
  urlparameterid: null,
  isdefaultdisplayed: true,
  itemcheckboxlabel:
    'Please check this box to agree to the <a href="https://www.harbourshare.com/e-signature-consent" target="_blank">Terms and Conditions</a> of Electronic Signature Consent.',
  itemcheckedvalueno: 'NO',
  itemcheckedvalueyes: 'YES',
  itemdefaultvalue: 'NO',
  itemdisplaylabel: null,
  itemicon: null,
  itemiconpack: 'fal',
  itemgroup: 'esignconsent',
  itemid: `agreementinput-${Date.now()}-${Math.floor(Math.random() * 1000000000000)}`,
  itemoptions: [],
  itemrecordlabel: 'E-sign consent',
  itemrespondednomessage: null,
  itemrespondedyesmessage: null,
  itemspeciallinkedvalue: null,
  itemtype: 'CHECKBOX',
  iteminputtededitorselectiontype: 'CHECKBOX',
  itemvalidations: [
    {
      itemvalidationcustommsg:
        'Please agree to sign electronically or contact the individual who sent you this agreement link to proceed via paper.',
      itemvalidationtruecount: 1,
      itemvalidationtype: 'REQUIREDGROUPCOUNTMIN',
    },
    {
      itemvalidationcustommsg:
        'Please agree to sign electronically or contact the individual who sent you this agreement link to proceed via paper.',
      itemvalidationtype: 'REQUIREDTRUE',
    },
  ],
  isautoinserteddefaultitem: true,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
};

export const AGREEMENT_INPUT_FINALDISPLAYTEXT = {
  isurlparametervalueenabled: false,
  urlparameterid: null,
  isconditionallydisplayedlinkeditemid: null,
  isconditionallydisplayedlinkeditemvalue: null,
  isdefaultdisplayed: true,
  itemannotation: null,
  itemcallouttype: 'is-light',
  itemcontent: `
      <a class="review-document review-document--final-review" href="#AGREEDOCUMENT" data-submit-btn="true">
        <i class="review-document__icon review-document__icon--green fa-solid fa-file-check"></i>
        <div class="review-document__text">Preview the document before submitting</div>
        <div class="review-document__btn">Final review</div>
      </a>
    `,
  itemdefaultvalue: null,
  itemdisplaylabel: null,
  itemicon: 'file-pdf',
  itemiconpack: 'fal',
  itemid: `agreementinput-agreementpdf-${Date.now()}-${Math.floor(Math.random() * 1000000000000)}`,
  iteminputtextmaxlength: 50,
  iteminputtextmaxlengthshowcounter: null,
  iteminputtype: null,
  itemiscalloutmsg: false,
  itemplaceholdertext: null,
  itemrecordlabel: null,
  itemrespondednomessage: null,
  itemrespondedyesmessage: null,
  itemspeciallinkedvalue: null,
  itemtype: 'FINALDISPLAYTEXT',
  iteminputtededitorselectiontype: 'FINALDISPLAYTEXT',
  itemvalidations: [],
  itemvisiblerequiredindex: null,
  itemvisiblerequiredrole: null,
  isautoinserteddefaultitem: true,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
  documentanchor: null, // for scrolling on document preview open
};

export const AGREEMENT_INPUT_FINALSUBMIT = {
  isurlparametervalueenabled: false,
  urlparameterid: null,
  itemannotation: null,
  itemcallouttype: null,
  itemcontent: '',
  itemicon: null,
  itemiconpack: 'fal',
  itemdisplaylabel: 'Complete the agreement by clicking below',
  itemid: `agreementinput-${Date.now()}-${Math.floor(Math.random() * 1000000000000)}`,
  itemiscalloutmsg: false,
  itemrecordlabel: null,
  itemspeciallinkedvalue: null,
  iteminputtededitorselectiontype: 'SUBMITBUTTON',
  itemtype: 'FINALSUBMIT',
  itemvalidations: [],
  isautoinserteddefaultitem: true,
  isautocompleteenabled: false,
  isautocompletewithmaps: false,
  isautocompletewithfullsuggestiontext: false,
  autocompletesuggestionstype: null,
};

// for replcing characters in docx
export const DOCX_REPLACE_DICT = {
  '\t': '%%HRBR_TAB%%',
};

// for replacing tokens characters in html from docx
export const HTML_REPLACE_DICT = {
  '%%HRBR_TAB%%': '&nbsp;'.repeat(40),
};

export const DOCX_LIST_MARKER = 'HRBR_LIST_ITEM_NUMBER';
